import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetDocPDFPresignedURLV2 = (matterId: string | undefined, docId: string | undefined) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery(
    [QueryEntity.PresignedGetDocumentPDF, { docId }],
    async () => {
      try {
        const downloadResult = await fetch(
          `${APIBaseChronos}/api/matters/${matterId}/docs/${docId}/pdf`,
          fetchConfigGET,
        );

        if (!downloadResult.ok) throw new Error('Fetching document url failed');

        return await downloadResult.text();
      } catch {
        return null;
      }
    },
    {
      enabled: !!matterId && !!docId,
      refetchOnWindowFocus: false,
    },
  );
};
